const isInPreviewMode = (() => {
  const loc = window.location.href.toLowerCase();
  return loc.includes("previewurl") || loc.includes("previewmode");
})();

const isInBeta = (() => {
  const loc = window.location.href.toLowerCase();
  return loc.includes("beta") && loc.includes("gyreteams");
})();

const uiConfig = {
  nodeEnv: process.env.NODE_ENV || "",
  isInPreviewMode,
  isInBeta,
  useRemoteCms: true,

  mixpanelToken: process.env.VUE_APP_MIXPANEL_TOKEN || "",
  sentryDsn: process.env.VUE_APP_SENTRY_DSN || "",

  version: process.env.VUE_APP_VERSION || "MISSING_REVISION_NO",
  buildNumber: process.env.VUE_APP_BUILD_NUMBER || "0",
  gitRevision: process.env.VUE_APP_GIT_REVISION || "MISSING_GIT_REVISION",
  release: process.env.VUE_APP_RELEASE || "MISSING_RELEASE",

  myCsUrl: process.env.VUE_APP_MY_CS_URL || "/",
  csApiUrl: `${(process.env.VUE_APP_MY_CS_URL || "").replace(/\/+$/, "")}/api`,
  chargebeeSiteName: process.env.VUE_APP_CHARGEBEE_SITE_NAME || "jyre-test",
  recaptchaSiteKey: process.env.VUE_APP_RECAPTCHA_SITE_KEY || "",
  // Currently unused - i think!
  appseeApiKey: process.env.VUE_APP_APPSEE_API_KEY || process.env.APPSEE_API_KEY || "",
  debugEnabledEmails: process.env.VUE_APP_DEBUG_ENABLED_EMAILS || "",
};

// Safety check
Object.keys(uiConfig).forEach((x) => {
  if (uiConfig[x] === "undefined") {
    throw new Error(`uiConfig.${x} is set to the string 'undefined'`);
  }
});

export default uiConfig;
